module.exports = __webpack_public_path__ + "static/grow-manager-bd16ce916af5669ef5dde4d1a8a87564.png";